module.exports = __webpack_public_path__ + "img/text-image-block.85922363.svg";